import type {AppConfig} from '$types/configs';

const origin = typeof window !== 'undefined' ? window.origin : '';

const appConfig: AppConfig = {
  mode: import.meta.env.MODE || '',

  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || origin,
  pdfBaseUrl: import.meta.env.GITE_PDF_BASE_URL || origin,

  google: {
    analytics: {uaCode: import.meta.env.VITE_GOOGLE_ANALYTICS_UA_CODE},
    maps: {apiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY},
  },

  sentry: {
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_SENTRY_ENV,
  },
};

export {appConfig};
